<template>
  <div class="basic-setting">
    <template v-if="readOnly">
      <base-section-title title="基本信息" class="m-b-24" />
      <el-form label-suffix="：">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="24" :xl="24">
            <el-form-item label="招标文件名称">
              {{ form.fileName }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="评审模式">{{ reviewModelLabel }}</el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="评审办法">
              {{ reviewMethodLabel }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="开标地点">{{ addressStr }}</el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="开标详细地址">
              {{ form.openBidAddress }}
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="中标候选人推荐">
              <template slot="label">
                <span class="m-r-8">中标候选人推荐</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="默认推荐对应候选人数量在评审报告中体现"
                  placement="top"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
                ：
              </template>
              <span>默认推荐前{{ form.recommendCandidateNum }}家</span>
            </el-form-item>
          </el-col>

          <el-col v-if="showItemOffer" :xs="24" :sm="12" :xl="8">
            <el-form-item label="是否开启分项报价">
              {{ form.isEnableItemOffer ? '是' : '否' }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>

    <template v-else>
      <base-section-title title="设置基本信息" class="m-b-24" />
      <el-form ref="formRef" :model="form" :rules="rules" label-position="top">
        <el-row :gutter="40">
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="招标文件名称" prop="fileName">
              <el-input
                v-model="form.fileName"
                class="form-input"
                placeholder="请输入"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="评审模式" prop="reviewModel">
              <el-select
                v-model="form.reviewModel"
                placeholder="请选择"
                @change="onReviewModelChange"
              >
                <el-option
                  v-for="item in reviewModelOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="评审办法" prop="reviewMethod">
              <el-select v-model="form.reviewMethod" placeholder="请选择">
                <el-option
                  v-for="item in reviewMethodModelOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item label="开标地点" prop="openBidCountry">
              <base-area-select
                style="width: 360px"
                :show-country="true"
                :address.sync="address"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item
              class="form-col"
              label="开标详细地址"
              prop="openBidAddress"
            >
              <el-input
                v-model="form.openBidAddress"
                class="form-input"
                placeholder="请输入"
                maxlength="200"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :xl="8">
            <el-form-item
              class="form-col"
              label="中标候选人推荐"
              prop="recommendCandidateNum"
            >
              <template slot="label">
                <span class="m-r-8">中标候选人推荐</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="默认推荐对应候选人数量在评审报告中体现"
                  placement="top"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
                ：
              </template>
              默认推荐前
              <el-input-number
                v-model="form.recommendCandidateNum"
                controls-position="right"
                size="small"
                :min="1"
                :max="99"
                :precision="0"
              />
              家
            </el-form-item>
          </el-col>
          <el-col v-if="showItemOffer" :xs="24" :sm="12" :xl="8">
            <el-form-item
              class="form-col"
              label="是否开启分项报价"
              prop="isEnableItemOffer"
            >
              <el-radio-group
                v-model="form.isEnableItemOffer"
                @change="openTip"
              >
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </template>
  </div>
</template>

<script>
import BaseAreaSelect from '@/components/common/BaseAreaSelect.vue'
import BaseSectionTitle from '@/components/common/BaseSectionTitle.vue'
import { requiredRule } from '@/utils/form-validate'
import { Modal } from 'ant-design-vue'
import { cloneDeep, isEqual } from 'lodash'
import {
  reviewMethodModelDict,
  reviewModelDict
} from '@/dictionary/project/kpb-project'

export default {
  name: 'FileBasicSetting',

  components: { BaseAreaSelect, BaseSectionTitle },

  model: {
    prop: 'info',
    event: 'change'
  },

  props: {
    info: {
      type: Object,
      default: () => {}
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        // 招标文件名称
        fileName: '',
        // 开标地点
        openBidCountry: '中国',
        openBidProvince: '',
        openBidCity: '',
        openBidArea: '',
        openBidAddress: '',
        // 中标候选人推荐数量
        recommendCandidateNum: undefined,
        // 报价文件解密时间限制
        // 是否开启分项报价
        isEnableItemOffer: 0,
        // 评审模式
        reviewModel: reviewModelDict.DEFAULT.value,
        // 评审办法
        reviewMethod: reviewMethodModelDict.DEFAULT.value
      },
      rules: {
        fileName: requiredRule('请输入电子化招标文件名称'),
        openBidCountry: [
          requiredRule('请选择地址'),
          {
            validator: (rule, value, callback) => {
              if (value === '中国') {
                if (
                  !(
                    this.form.openBidProvince &&
                    this.form.openBidCity &&
                    this.form.openBidArea
                  )
                ) {
                  callback(new Error('请选择地址'))
                }
              } else if (value === '国外') {
                callback(new Error('请输入地址'))
              }
              callback()
            },
            trigger: ['blur', 'change']
          }
        ],
        openBidAddress: requiredRule('请输入详细地址'),
        recommendCandidateNum: requiredRule('请输入中标候选人推荐数量')
      }
    }
  },

  computed: {
    address: {
      get() {
        return {
          country: this.form.openBidCountry || '中国',
          province: this.form.openBidProvince,
          city: this.form.openBidCity,
          county: this.form.openBidArea,
          foreign:
            this.form.openBidCountry !== '中国' ? this.form.openBidCountry : ''
        }
      },
      set(value) {
        const { country, province, city, county, foreign } = value
        this.form.openBidCountry = country
        this.form.openBidProvince = province
        this.form.openBidCity = city
        this.form.openBidArea = county

        if (foreign) {
          this.form.openBidCountry = foreign
        }
      }
    },

    addressStr() {
      if (this.form.openBidCountry === '中国') {
        return `${this.form.openBidProvince}-${this.form.openBidCity}-${this.form.openBidArea}`
      } else {
        return this.form.openBidCountry
      }
    },

    // 评审模式选项
    reviewModelOption() {
      return reviewModelDict.array || []
    },

    // 评审办法选项
    reviewMethodModelOption() {
      // 如果评审模式是综合打分，则只有综合评分法
      if (this.form.reviewModel === reviewModelDict.DEFAULT.value) {
        return [reviewMethodModelDict.DEFAULT]
      }
      // 如果是双信封，则有三种评审办法模式
      return reviewMethodModelDict.array || []
    },

    showItemOffer() {
      // 双信封报价不允许设置分项报价
      return !this.isDouble
    },

    // 是否是双信封
    isDouble() {
      return this.form.reviewModel === reviewModelDict.DOUBLE.value
    },

    reviewModelLabel() {
      return reviewModelDict.translate(this.form.reviewModel)?.label
    },

    reviewMethodLabel() {
      return reviewMethodModelDict.translate(this.form.reviewMethod)?.label
    }
  },

  watch: {
    info: {
      handler(value) {
        if (value) {
          this.form = cloneDeep(value)
          // 如果评审模式和评审办法为0，则默认设置为综合打分和综合评分法
          if (this.form.reviewModel === 0) {
            this.form.reviewModel = reviewModelDict.DEFAULT.value
          }
          if (this.form.reviewMethod === 0) {
            this.form.reviewMethod = reviewMethodModelDict.DEFAULT.value
          }
        }
      },
      deep: true,
      immediate: true
    },

    form: {
      handler(value) {
        if (value && !isEqual(value, this.info)) {
          this.$emit('change', cloneDeep(value))
        }
      },
      deep: true
    }
  },

  methods: {
    /**
     * 当选择开启分项报价时候，打开提示
     */
    openTip() {
      if (this.form.isEnableItemOffer) {
        Modal.confirm({
          title: '系统提示',
          icon: () =>
            this.$createElement('a-icon', {
              props: {
                type: 'exclamation-circle',
                theme: 'filled'
              }
            }),
          content: (
            <div>
              若开启了分项报价，在评标阶段不支持发起二次报价，是否确认当前操作?
            </div>
          ),
          cancelText: '取消',
          okText: '确认',
          onCancel: () => {
            this.form.isEnableItemOffer = 0
          }
        })
      }
    },

    validateSettingForm() {
      return new Promise((resolve, reject) => {
        this.$refs.formRef.validate(valid => {
          if (!valid) {
            this.$message.error('基本信息设置有误，请重新设置')
            reject()
            return
          }
          resolve()
        })
      })
    },

    /**
     * 评审模式切换
     */
    onReviewModelChange() {
      // 当切换至综合打分，则要将评审办法重置为综合评分
      if (this.form.reviewModel === reviewModelDict.DEFAULT.value) {
        this.form.reviewMethod = reviewMethodModelDict.DEFAULT.value
      }
      this.$emit('changeModel', this.form.reviewModel)
    }
  }
}
</script>

<style scoped lang="scss">
.basic-setting {
  background: $white-color;
  border-radius: 4px;
  padding: 20px;
}
</style>
